import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead, bufferById } from 'selectors/common'
import { transactions, merchants, leases, projects, comments } from 'selectors/entities'
import { makePropertyVendorsSelector } from 'selectors/vendor'
import { findInCollection } from 'utils/search'

import FormHeader from 'components/FormHeader'
import FormFooter from 'components/FormFooter'
import LeftSide from './LeftSide'
import RightSide from './RightSide'
import Deleted from 'components/Deleted'
import PropertyStatusIcon from '../properties/StatusIcon'
import Divider from 'material-ui/Divider'
import Geolocation from 'components/drivers/Geolocation'

let select = dirtyRead(
	(state, props) => {
		let propertyVendors = makePropertyVendorsSelector()
		return ({
			property: doc(state, props.id || props.routeParams.id)
		  , isEditing: !!bufferById(state, props.id || props.routeParams.id)
		  , vendors: merchants(state)
		  , transactions: transactions(state)
		  , leases: leases(state)
		  , projects: projects(state)
		  , comments: comments(state)
		})
	}
)

export class PropertyForm extends Component{
	render(){
		let propertyID = this.props.id || this.props.routeParams.id
		let colspan = this.props.colspan || 2
		let property = this.props.property || {}
		let widthColumns = (this.props.style && this.props.width && colspan)?(this.props.width.split('px')[0]/colspan)-18+"px":"50%"
		return(
			<div
				style={{
					display: "inline-block"
				  , width: "100%"
				  , overflow: "hidden"
				}}
			>
				{this.props.property && (!this.props.property.cors || !Object.keys(this.props.property.cors).length) && this.props.property.address && <Geolocation
					address={this.props.property.address}
					onSuccess={(cors) => this.props.STAGE({_id: propertyID, cors: (JSON.parse(cors).results.length) ? JSON.parse(cors).results[0].geometry.location : {}})}
				/>}
				<FormHeader
					title={(this.props.property && this.props.property.alias)? this.props.property.alias : this.props.isEditing && "New property"}
					statusIcon={<div style={{position:"relative", margin:"auto", top:"-5px", left:"-3px"}}><PropertyStatusIcon id={propertyID} /></div>}
					masterDetail={this.props.masterDetail || false}
					objectID= {propertyID}
					entity='property'
					deleteDisabled={
						findInCollection(x => x.propertyID == propertyID, this.props.transactions) ? 'Has transaction(s)' :
							findInCollection(x => x.propertyID == propertyID, this.props.projects) ? 'Has project(s)' :
								findInCollection(x => x.property == propertyID, this.props.leases) ? 'Has lease(s)' :
									findInCollection(x => x.propertyID == propertyID, this.props.vendors) ? 'Has vendor(s)' :
										property.status != 'Retired' ? 'Not retired' :
											property.owner || property.ownerID ? 'Owner assigned':
												findInCollection(x => x.objectID == propertyID, this.props.comments) ? 'Has comment(s)' :
													property.agentID ? 'Agent assigned':
														property.attachmentsIDs && property.attachmentsIDs.length ? 'Has attachment(s)':
															''
					}
				/>
				{(!this.props.property)?
					<Deleted />
					:
					<div style={{position:"relative", height:"calc(100vh - 64px)", overflowX: "hidden"}}>
					<main style={{height:"calc(100vh - 64px)", display:(colspan>1)?"flex":"block"}}>
		  				<LeftSide propertyID={propertyID} colspan={colspan}/>
						{colspan==1 && <Divider style={{marginTop: "0px"}}/>}
						<RightSide propertyID={propertyID} colspan={colspan} propertyAlias={(this.props.property.alias)?this.props.property.alias:"All properties"}/>
					</main>
					{propertyID &&
						<div
							style={{
								position:"fixed"
						      , zIndex:"9999"
							  , bottom:"3px"
							  , right:"17px"
							  , boxSizing: "borderBox"
							  , maringRight: "17px"
							}}
						>
							<FormFooter masterDetail={this.props.masterDetail || false} objectID={propertyID} />
						</div>
					}
					</div>
				}

			</div>
		)
	}
}

export default connect(select, dataActions)(PropertyForm)



// WEBPACK FOOTER //
// ./src/routes/manager/propertyForm/index.js